/*** IMPORTS FROM imports-loader ***/
(function() {

define(['jquery', 'mustache'], function($, Mustache) {

    var templates = {
        overlay:    '<div class="pip-overlays-wrapper">' +
                        '<div class="pip-overlay {{class}}">' +
                            '<div class="pip-icons close pip-overlay__close-btn">">Close</div>' +
                            '<div>{{{content}}}</div>' +
                        '</div>' +
                    '</div>'
    };

    var Overlay = function Overlay(overlayClassName, content) {
        this.content = content;
        this.overlayClassName = overlayClassName;

        var _this = this;

        $(document).off('.pipoverlay');
        $(document).on('click.pipoverlay', _this.close);
        $(document).on('click.pipoverlay', '.pip-overlay__close-btn', _this.close);
        $(document).on('click.pipoverlay', '.pip-overlay', function(e){
            e.stopPropagation();
        });
    };

    Overlay.prototype.show = function show() {
        var overlay = Mustache.render(templates.overlay, {content: this.content, class: this.overlayClassName});
        $('body').append(overlay);
        $('.pip-overlays-wrapper').fadeIn();
    };

    Overlay.prototype.close = function close() {
        $('.pip-overlays-wrapper').fadeOut('fast', function(){
            $(this).remove();
        });
    };

    return {
        create: function create (overlayClassName, content){
            return new Overlay(overlayClassName, content);
        }
    }
});
}.call(window));